import { render, staticRenderFns } from "./CustomPieChart.vue?vue&type=template&id=080f00b0&scoped=true"
import script from "./CustomPieChart.vue?vue&type=script&lang=js"
export * from "./CustomPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f00b0",
  null
  
)

export default component.exports